/* v52: email signup with welcome discount. Upgrades form.pf-signup (no page reload, code shown at once, code applied to the cart) and runs the popup. */
(function () {
  'use strict';
  var PFS = (window.PFStrings || {});
  function pfs(key, fallback){ return (PFS && PFS[key]) || fallback; }
  var KEY = 'pf_signup_v2';      /* localStorage: done = subscribed, never show again on this device */
  var SKEY = 'pf_popup_seen';    /* sessionStorage: shown this visit, back on the next visit */
  var FORCE = /[?&]popup=1/.test(location.search);

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function markDone() { var s = read(); s.done = true; write(s); }
  function seenThisVisit() { try { return sessionStorage.getItem(SKEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(SKEY, '1'); } catch (e) {} }

  /* A visitor who just subscribed the normal way (page reload) never sees the popup again. */
  if (/[?&]customer_posted=true/.test(location.search)) { markDone(); }

  function codeOf(el) {
    var s = el && el.querySelector ? el.querySelector('.pf-signup__code strong') : null;
    return s ? s.textContent.trim() : '';
  }

  function applyCode(form) {
    /* Visiting /discount/CODE stores the code for checkout. Done quietly in the background. */
    var code = codeOf(form);
    if (!code) { return; }
    try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {}); } catch (e) {}
  }

  function showDone(form) {
    var row = form.querySelector('.pf-signup__row');
    var fine = form.querySelector(':scope > .pf-signup__fine');
    var err = form.querySelector('.pf-signup__error');
    var done = form.querySelector('.pf-signup__done');
    if (row) { row.hidden = true; row.style.display = 'none'; }
    if (fine) { fine.hidden = true; }
    if (err) { err.remove(); }
    if (done) { done.hidden = false; }
    markDone();
    applyCode(form);
  }

  function showError(form, msg) {
    var err = form.querySelector('.pf-signup__error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'pf-signup__error';
      err.setAttribute('role', 'alert');
      form.insertBefore(err, form.querySelector('.pf-signup__done'));
    }
    err.textContent = msg;
  }

  function nativeSubmit(form) {
    /* HTMLFormElement.submit() does not fire the submit event, so no loop. */
    HTMLFormElement.prototype.submit.call(form);
  }

  function enhance(form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) { return; }
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = pfs('one_moment', 'One moment'); }
      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      }).then(function (res) {
        var url = res.url || '';
        if (res.ok && /[?&]customer_posted=true/.test(url)) {
          showDone(form);
        } else if (url.indexOf('/challenge') > -1 || !res.ok) {
          /* Shopify wants a bot check: let the browser do the normal submit. */
          nativeSubmit(form);
        } else {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          showError(form, pfs('invalid_email', 'Please enter a valid email address.'));
        }
      }).catch(function () {
        nativeSubmit(form);
      });
    });
  }

  document.querySelectorAll('form.pf-signup').forEach(enhance);

  /* Copy button */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-pf-copy]') : null;
    if (!b) { return; }
    var code = codeOf(b.closest('.pf-signup__done'));
    var ok = function () { b.textContent = pfs('copied', 'Copied'); setTimeout(function () { b.textContent = pfs('copy', 'Copy'); }, 1800); };
    if (code && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(ok, function () {});
    }
  });

  /* Popup */
  var dlg = document.getElementById('pf-signup-popup');
  if (!dlg || typeof dlg.showModal !== 'function') { return; }

  if (!FORCE) {
    if (read().done) { return; }
    if (seenThisVisit()) { return; }
    if (/[?&]customer_posted=true/.test(location.search)) { return; }
  }

  var shown = false;
  var delay = parseInt(dlg.getAttribute('data-delay'), 10) || 3000;
  var timer = null;

  function busy() { var a = document.activeElement; return a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName); }
  function open() {
    if (shown) { return; }
    if (busy() || document.querySelector('dialog[open]') || document.hidden) {
      /* Typing, another dialog open, or tab in the background: try again shortly. */
      timer = setTimeout(open, 1500);
      return;
    }
    shown = true;
    cleanup();
    dlg.showModal();
    document.documentElement.classList.add('pf-pop-open');
    if (!FORCE) { markSeen(); }
  }
  function onScroll() {
    /* Scrolling counts as engagement: open as soon as the visitor has moved a bit. */
    if (window.scrollY > 200) { open(); }
  }
  function cleanup() {
    window.removeEventListener('scroll', onScroll);
    if (timer) { clearTimeout(timer); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  timer = setTimeout(open, FORCE ? 300 : delay);

  dlg.addEventListener('close', function () { document.documentElement.classList.remove('pf-pop-open'); });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || (e.target.closest && e.target.closest('[data-pf-close]'))) { dlg.close(); }
  });
})();
